import { HeaderLink } from '../../components';

export const productLinks: HeaderLink[] = [
  { href: '/#whyPartnerWithUs', label: 'WHY PARTNER WITH US', newTab: false },
  { href: '/#HowCanHelp', label: 'HOW WE CAN HELP', newTab: false },
  { href: '/#OurProducts', label: 'OUR PRODUCTS', newTab: false },
];
